var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    {
      attrs: {
        effect: "dark",
        content: _vm.tooltipContent,
        placement: "bottom"
      }
    },
    [
      _c(
        "el-button",
        {
          staticClass: "d2-ml-0 d2-mr btn-text can-hover",
          attrs: { type: "text" },
          on: { click: _vm.handleClick }
        },
        [
          _vm.unreadCount !== 0
            ? _c(
                "el-badge",
                {
                  attrs: {
                    max: 99,
                    value: _vm.unreadCount,
                    "is-dot": _vm.unreadCount === 0
                  }
                },
                [
                  _c("i", {
                    staticClass: "el-icon-s-comment",
                    staticStyle: {
                      "font-size": "20px",
                      width: "20px",
                      height: "20px"
                    }
                  })
                ]
              )
            : _c("i", {
                staticClass: "el-icon-s-comment",
                staticStyle: {
                  "font-size": "20px",
                  width: "20px",
                  height: "20px"
                }
              })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }